import {
  ArrowRightAlt,
  CalendarMonth,
  CheckCircleRounded,
  Comment,
  Favorite,
  ModeComment,
  Star,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Divider,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./BlogItem.css";

const BlogItem = (props) => {
  const navigate = useNavigate();
  const { blogData } = props;
  const { blog_id, pic, category, article_info, con_image, title, timeStamp } =
    blogData;
  let detail = article_info?.[0]?.details.slice(0, 200);
  return (
    <Card
      onClick={() => navigate("/blogdetails/" + pic)}
      sx={{
        width: "100%",
        borderRadius: 3, // 12px
        cursor: "pointer",
        transition: "box-shadow 0.3s ease",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        "&:hover": {
          boxShadow: "0 6px 20px rgba(25,118,210,0.4)", // subtle blue glow on hover
        },
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        bgcolor: "#fff",
      }}
    >
      {/* Image Section */}
      <Box sx={{ position: "relative", height: { xs: 180, md: 220 } }}>
        <CardMedia
          component="img"
          src={
            con_image?.[0]?.pic_url
              ? "//yeapbe.com/" + con_image[0].pic_url
              : "https://ghorami.com/image/catPic/creative_work.jpg"
          }
          alt={title}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          }}
        />

        {/* Blog ID Tag */}
        <Box
          sx={{
            position: "absolute",
            bottom: 12,
            left: 12,
            bgcolor: "#0D47A1", // Songjukti blue dark variant
            px: 2,
            py: 0.5,
            borderRadius: 1,
            boxShadow: "0 0 8px #0D47A1AA",
            fontWeight: "bold",
            fontSize: 16,
            color: "#fff",
            userSelect: "none",
            fontFamily: "'Poppins', sans-serif",
          }}
        >
          #{blog_id}
        </Box>
      </Box>

      {/* Content Section */}
      <Stack
        spacing={1}
        sx={{
          p: { xs: 2, md: 3 },
          flexGrow: 1,
          justifyContent: "space-between",
        }}
      >
        {/* Title */}
        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1rem", md: "1.125rem" },
            color: "#212121",
            lineHeight: 1.3,
            fontFamily: "'Poppins', sans-serif",
          }}
          noWrap
          title={title}
        >
          {title}
        </Typography>

        {/* Meta info */}
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          sx={{ color: "gray", fontSize: { xs: "0.8rem", md: "0.9rem" } }}
        >
          <Typography noWrap>{timeStamp}</Typography>
          <Typography>|</Typography>
          <Typography sx={{ color: "#397FE6", fontWeight: 600 }}>
            {category}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

export default BlogItem;
